export function leaseOwnerChanged(previousGeneration: number | undefined, currentGeneration: number): boolean {
  return previousGeneration !== undefined
    ? previousGeneration !== currentGeneration
    : currentGeneration > 1;
}

export function leaseContactExpired(lastContact: number, now: number, timeoutMs = 30_000): boolean {
  return now - lastContact >= timeoutMs;
}
